/**
 * Miscellaneous constants.
 * @module constants
 *
 */

const MEASURE_SCORES = 'measureScores';
const FLO_PREC = 'FLO-ACC';
const SUPPORTED_MEASURES = [
    'FNL',
    'FSS',
    'FSL',
    'LSS',
    'FEP',
    'FLO',
    'FLO-ACC',
    'CLPL',
];

const COMPOSITE_SCORE_WITH_PAUSED_INTERP = {
    compositeScore: null,
    interpretation: 'Paused, No Interpretation',
};

module.exports = {
    MEASURE_SCORES,
    FLO_PREC,
    SUPPORTED_MEASURES,
    COMPOSITE_SCORE_WITH_PAUSED_INTERP,
};
